<template>
	<div>
		<div :class="(breakpoint ? 'modal-' + breakpoint : '')" class="modal-container shadowed">
			<div class="modal-title">
				{{ title }}
				<button class="modal-close" @click="$emit('close')" :disabled="loading">
					<i class="fa fa-times"></i>
				</button>
			</div>
			<div class="modal-body">
				<slot></slot>
			</div>
			<div class="modal-footer">
				<button class="modal-button-close" @click="$emit('close')" :disabled="loading">
					<i v-if="loading" class="fa fa-fw fa-circle-notch fa-spin"></i>
					<i v-if="!loading" class="fa fa-angle-left"></i> 
					FECHAR
				</button>

				<button class="modal-button-save" v-if="has_save_listener" @click="$emit('save')" :disabled="loading">
					PRONTO 
					<i v-if="loading" class="fa fa-fw fa-circle-notch fa-spin"></i>
					<i v-if="!loading" class="fa fa-fw fa-angle-right"></i>
				</button>
			</div>
		</div>
		<div class="modal-background" @click="$emit('close')"></div>
	</div>
</template>


<script>
	export default {
		name: "Modal",

		props: {
			loading: {
				type: Boolean,
				require: false,
			},
			title: {
				type: String,
				require: true,
			}, 
			breakpoint: {
				type: String,
				require: false,
				default: "",
			},
			on_save: {
				type: Boolean,
				require: false,
			},
		},

		data: function() {
			return {
				
			};
		},

		methods: {

		},

		computed: {
			has_save_listener: function() {
				return this.$listeners && this.$listeners.save;
			},
		},

	}
</script>


<style scoped>

.modal-background {
	width: 100vw;
	height: 100vh;
	position: absolute;
	top:0;
	left:0;
	background: #222222cc;
	z-index: 2;
}

.modal-container {
	position: absolute;
	margin: auto;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	height: calc(100vh - 60px);
	max-width: 800px;
	background: #fff;
	border-radius: 4px;
	border: 1px solid #ddd;
	z-index: 3;
}

.modal-md {
	max-width: 720px;
}
.modal-lg {
	max-width: 960px;
}

.modal-xl {
	max-width: calc(100vw - 30px);
}

.modal-title {
	position: relative;
	border-bottom: 1px solid #ddd;
	height: 50px;
	line-height: 50px;
	padding: 0 15px 0 15px;
	font-weight: bold;
	background: #f9f9f9;
}

.modal-close {
	position: absolute;
	top: 12px;
	right: 15px;
	font-size: 20px;
	background: none;
	border: none;
	color: #999;
}

.modal-body {
	padding: 15px;
	width: 100%;
	height: calc(100% - 120px);
	overflow: auto;
}

.modal-footer {
	width: 100%;
	height: 70px;
	border-top: 1px solid #ddd;
	background: #f9f9f9;
}




.modal-button-close {
	background: #fff;
	border: 2px solid #222;
	color: #222;
	width: 120px;
	height: 30px;
	line-height: 25px;
	margin-left: 15px;
	margin-top: 15px;
	font-size: 12px;
	font-weight: bold;
}

.modal-button-save {
	float: right;
	background: #0a600a;
	color: #fff;
	border: none;
	width: 120px;
	height: 30px;
	line-height: 25px;
	margin-right: 15px;
	margin-top: 15px;
	font-size: 12px;
	font-weight: bold;
}

</style>